import { render, staticRenderFns } from "./LogCare.vue?vue&type=template&id=5845976c&"
import script from "./LogCare.vue?vue&type=script&lang=js&"
export * from "./LogCare.vue?vue&type=script&lang=js&"
import style0 from "./LogCare.vue?vue&type=style&index=0&id=5845976c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports